import {InputProps} from 'antd';

import {useLocale} from '../../../../../../../../provider/locale/locale-hook';
import {getAbuseReasonLength} from '../../../../../../../../service/reviews/reviews-abuse-hook';
import {Form, FormInstance} from '../../../../../../../../typings/antd';

import {AbuseFormItemEnum, AbuseFormType} from './new-abuse-modal-const';

type AbuseReasonLimitType = {
    count?: InputProps['count'];
    isOverLimit: boolean;
};

// Counts the whole complaint (selected reasons + description) because that is the string the catalog receives.
export function useAbuseReasonLimit(form: FormInstance<AbuseFormType>, maxLength: number | null): AbuseReasonLimitType {
    const {getLocalizedString} = useLocale();
    const choices = Form.useWatch(AbuseFormItemEnum.Choices, form);
    const description = Form.useWatch(AbuseFormItemEnum.Description, form);

    if (maxLength === null) {
        return {isOverLimit: false};
    }

    const localizedChoices = (choices ?? []).map((choice) => getLocalizedString(choice));

    return {
        count: {
            max: maxLength,
            show: true,
            strategy: (value) => getAbuseReasonLength(localizedChoices, value),
        },
        isOverLimit: getAbuseReasonLength(localizedChoices, description ?? '') > maxLength,
    };
}
